import { store } from '@betacrew/jars-flux'
import { put, takeEvery, all, call } from 'redux-saga/effects'
import { componentKey, updatePageLoadingState, setIsEndUser } from './AppLoaderSlice';
import { PAGE_STATE } from '../../constants/constants';
import AppDataService from './../../../../services/AppDataService';
import Config from '../../../config.web.js';
import axios from 'axios';

export const { initApplication } = {
    initApplication: function(payload) {
        return {
            type: "APP_LOADER/INIT_APPLICATION",
            payload: payload
        }
    },
}

function* initApplicationAsync() {
    
    AppDataService.setBaseUrl(Config.BASE_URL);
    yield put(updatePageLoadingState(PAGE_STATE.PAGE_READY));
}

function* rootSaga() {
    yield all([
        takeEvery(initApplication().type, initApplicationAsync), 
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);